import React, { useState, useEffect } from "react";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useSearchParams } from "react-router-dom";

import { useTheme } from "@mui/material/styles";
import { Typography } from "@mui/material";

const IndicatorSelector = () => {
  const [state, setState] = useState({
    showRsi: false,
    showMacd: false,
    showAdx: false,
    showRoc: false,
    showBB: false,
  });
  const [loading, setLoading] = React.useState(true);

  let [searchParams, setSearchParams] = useSearchParams();

  const theme = useTheme();

  useEffect(() => {
    setLoading(true);
    if (searchParams.get("showRsi")) {
      setState((prevState) => ({
        ...prevState,
        showRsi: true,
      }));
    }
    if (searchParams.get("showMacd")) {
      setState((prevState) => ({
        ...prevState,
        showMacd: true,
      }));
    }
    if (searchParams.get("showAdx")) {
      setState((prevState) => ({
        ...prevState,
        showAdx: true,
      }));
    }
    if (searchParams.get("showRoc")) {
      setState((prevState) => ({
        ...prevState,
        showRoc: true,
      }));
    }
    if (searchParams.get("showBB")) {
      setState((prevState) => ({
        ...prevState,
        showBB: true,
      }));
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!loading) {
      let params = new URLSearchParams(searchParams);
      for (const key of Object.keys(state)) {
        if (state[key]) {
          if (!params.get(key)) {
            params.append(key, "true");
          }
        } else {
          params.delete(key);
        }
      }
      setSearchParams(params);
    }
  }, [state]);

  const handleRsiToggle = () => {
    setState((prevState) => ({
      ...prevState,
      showRsi: !prevState.showRsi,
    }));
  };

  const handleMacdToggle = () => {
    setState((prevState) => ({
      ...prevState,
      showMacd: !prevState.showMacd,
    }));
  };

  const handleAdxToggle = () => {
    setState((prevState) => ({
      ...prevState,
      showAdx: !prevState.showAdx,
    }));
  }

  const handleRocToggle = () => {
    setState((prevState) => ({
      ...prevState,
      showRoc: !prevState.showRoc,
    }));
  }

  const handleBBToggle = () => {
    setState((prevState) => ({
      ...prevState,
      showBB: !prevState.showBB,
    }));
  }

  return (
    <div >
      <FormGroup row color={theme.palette.primary.main}>
        <FormControlLabel
          control={
            <Switch
              checked={state.showRsi}
              onChange={handleRsiToggle}
            />
          }
          label={<Typography color={theme.palette.primary.main}>RSI</Typography>}
        />
        <FormControlLabel
          control={
            <Switch
              checked={state.showMacd}
              onChange={handleMacdToggle}
            />
          }
          label={<Typography color={theme.palette.primary.main}>MACD</Typography>}
        />
        <FormControlLabel
          control={
            <Switch
              checked={state.showAdx}
              onChange={handleAdxToggle}
            />
          }
          label={<Typography color={theme.palette.primary.main}>ADX</Typography>}
        />
        <FormControlLabel
          control={
            <Switch
              checked={state.showRoc}
              onChange={handleRocToggle}
            />
          }
          label={<Typography color={theme.palette.primary.main}>ROC</Typography>}
        />
        <FormControlLabel
          control={
            <Switch
              checked={state.showBB}
              onChange={handleBBToggle}
            />
          }
          label={<Typography color={theme.palette.primary.main}>BB Width</Typography>}
        />
      </FormGroup>
    </div>
  );
};

export default IndicatorSelector;
